import {
  redirectToApprovalsIfNotAdmin,
  redirectToApprovalsIndexIfNotValidId,
  redirectToHomeIfNoApprovalsAccess,
} from '@/approvals/router/guards';
import { ifNotAdminRedirectTo } from '@/router/common-guards';

const ApprovalsPage = () => import('@/approvals/pages/approvals.vue');
const AtsSettingsPage = () => import('@/approvals/pages/ats-settings.vue');
const ApprovalsSettingsPage = () => import('@/approvals/pages/approvals-settings.vue');
const ApprovalChainsPage = () => import('@/approvals/pages/approval-chains.vue');
const CompTablesPage = () => import('@/approvals/pages/comp-tables.vue');
const CompTableNewPage = () => import('@/approvals/pages/comp-table-new.vue');
const CompTableEditPage = () => import('@/approvals/pages/comp-table-edit.vue');
const ApprovalChainNewPage = () => import('@/approvals/pages/approval-chain-new.vue');
const NewApprovalRequestPage = () => import('@/approvals/pages/new-approval-request.vue');
const ApprovalChainEditPage = () => import('@/approvals/pages/approval-chain-edit.vue');
const ApprovalRequestPage = () => import('@/approvals/pages/approval-request.vue');
const EditApprovalRequestPage = () => import('@/approvals/pages/edit-approval-request.vue');
const NoAccessPage = () => import('@/approvals/pages/no-access.vue');
const CustomFieldsPage = () => import('@/approvals/pages/custom-fields.vue');
const FieldsGroupsPage = () => import('@/approvals/pages/fields-groups.vue');
const FieldsGroupsNewPage = () => import('@/approvals/pages/fields-group-new.vue');
const FieldsGroupsEditPage = () => import('@/approvals/pages/fields-group-edit.vue');
const CustomFieldNewPage = () => import('@/approvals/pages/custom-field-new.vue');
const CustomFieldEditPage = () => import('@/approvals/pages/custom-field-edit.vue');
const CompetingOffersPage = () => import('@/approvals/pages/competing-offers.vue');
const NewApprovalRequestGHPage = () => import('@/approvals/pages/gh-approval-request.vue');
const ApprovalsExportPage = () => import('@/approvals/pages/export-page.vue');

export const approvalsRoutes = [
  {
    path: '/approvals',
    name: 'approvals',
    component: ApprovalsPage,
    beforeEnter: redirectToHomeIfNoApprovalsAccess,
  },
  {
    path: '/approvals/no-access',
    name: 'no-access',
    component: NoAccessPage,
  },
  {
    path: '/approvals/chains',
    name: 'approval-chains',
    component: ApprovalChainsPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToHomeIfNoApprovalsAccess, ifNotAdminRedirectTo('approvals')],
  },
  {
    path: '/approvals/ats-settings',
    name: 'ats-settings',
    component: AtsSettingsPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToHomeIfNoApprovalsAccess, ifNotAdminRedirectTo('approvals')],
  },
  {
    path: '/approvals/settings',
    name: 'approvals-settings',
    component: ApprovalsSettingsPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToHomeIfNoApprovalsAccess, ifNotAdminRedirectTo('approvals')],
  },
  {
    path: '/approvals/export',
    name: 'approvals-export',
    component: ApprovalsExportPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToHomeIfNoApprovalsAccess, ifNotAdminRedirectTo('approvals')],
  },
  {
    path: '/approvals/comp-tables',
    name: 'comp-tables',
    component: CompTablesPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToHomeIfNoApprovalsAccess, ifNotAdminRedirectTo('approvals')],
  },
  {
    path: '/approvals/comp-tables/new',
    name: 'comp-tables-new',
    component: CompTableNewPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToHomeIfNoApprovalsAccess, ifNotAdminRedirectTo('approvals')],
  },
  {
    path: '/approvals/comp-tables/:id/edit',
    name: 'comp-tables-edit',
    component: CompTableEditPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
  {
    path: '/approvals/chains/new',
    name: 'approval-chains-new',
    component: ApprovalChainNewPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
  {
    path: '/approvals/chains/:id/edit',
    name: 'approval-chains-edit',
    component: ApprovalChainEditPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
  {
    path: '/approvals/new',
    name: 'new-approval-request',
    component: NewApprovalRequestPage,
    beforeEnter: redirectToHomeIfNoApprovalsAccess,
  },
  {
    path: '/approvals/new-gh/:applicationId',
    name: 'new-approval-request-gh-chrome-extension',
    component: NewApprovalRequestGHPage,
    beforeEnter: redirectToHomeIfNoApprovalsAccess,
  },
  {
    path: '/approvals/competing-offers',
    name: 'approvals-competing-offers',
    component: CompetingOffersPage,
    beforeEnter: [redirectToHomeIfNoApprovalsAccess],
  },
  {
    path: '/approvals/:id',
    name: 'approval-request',
    component: ApprovalRequestPage,
    beforeEnter: [redirectToHomeIfNoApprovalsAccess, redirectToApprovalsIndexIfNotValidId],
  },
  {
    path: '/approvals/:id/edit',
    name: 'edit-approval-request',
    component: EditApprovalRequestPage,
    beforeEnter: [redirectToHomeIfNoApprovalsAccess, redirectToApprovalsIndexIfNotValidId],
  },
  {
    path: '/approvals/fields',
    name: 'custom-fields',
    component: CustomFieldsPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
  {
    path: '/approvals/fields-groups',
    name: 'fields-groups',
    component: FieldsGroupsPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
  {
    path: '/approvals/fields-groups/new',
    name: 'fields-groups-new',
    component: FieldsGroupsNewPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
  {
    path: '/approvals/fields-groups/:id/edit',
    name: 'fields-groups-edit',
    component: FieldsGroupsEditPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
  {
    path: '/approvals/fields/new',
    name: 'fields-new',
    component: CustomFieldNewPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
  {
    path: '/approvals/fields/:id/edit',
    name: 'fields-edit',
    component: CustomFieldEditPage,
    meta: {
      layout: 'layout-approvals-settings-default',
    },
    beforeEnter: [redirectToApprovalsIfNotAdmin],
  },
];
